import { ICONS } from '@/Icons';
import { FCWW } from 'types';
import { KeyboardEvent } from 'react';

export interface AccordionItemHeaderProps {
  unfolded?: boolean;
  toggleUnfolded?: () => void;
}

export const AccordionItemHeader: FCWW<AccordionItemHeaderProps> = ({ children, unfolded, toggleUnfolded }) => {
  const onKeyActivate = (e: KeyboardEvent<HTMLDivElement>) => {
    const key = e.key;

    // Activate on Enter/Space
    if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      e.preventDefault();
      toggleUnfolded?.();
      return;
    }

    // Arrow navigation between .accordion-item siblings
    if (key === 'ArrowDown' || key === 'ArrowRight' || key === 'ArrowUp' || key === 'ArrowLeft') {
      e.preventDefault();
      const headerEl = e.currentTarget as HTMLElement;
      const currentItem = headerEl.closest('.accordion-item') as HTMLElement | null;
      if (!currentItem || !currentItem.parentElement) return;

      const items = Array.from(currentItem.parentElement.querySelectorAll<HTMLElement>('.accordion-item'));
      if (items.length === 0) return;

      const currentIndex = items.indexOf(currentItem);
      if (currentIndex === -1) return;

      const backwards = key === 'ArrowUp' || key === 'ArrowLeft';
      const nextIndex = backwards
        ? currentIndex <= 0
          ? items.length - 1
          : currentIndex - 1
        : currentIndex >= items.length - 1
          ? 0
          : currentIndex + 1;

      const nextHeader = items[nextIndex].querySelector<HTMLElement>('.accordion-item-header');
      nextHeader?.focus();
    }
  };

  return (
    <div
      className={'accordion-item-header'}
      role="button"
      tabIndex={0}
      aria-expanded={!!unfolded}
      onClick={toggleUnfolded}
      onKeyDown={onKeyActivate}
    >
      <h4>{children}</h4>
      <span>
        <i className={'icon ' + (unfolded ? ICONS.minus : ICONS.plus)} />
      </span>
    </div>
  );
};
